/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCoffeeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-coffee"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.95 18.15Q7.72 18.15 5.46 15.9Q3.2 13.65 3.2 10.43L3.2 4.83Q3.2 3.73 3.96 2.96Q4.72 2.2 5.83 2.2L18.77 2.2Q20.45 2.2 21.63 3.4Q22.8 4.6 22.8 6.3Q22.8 8 21.63 9.2Q20.45 10.4 18.77 10.4L18.68 10.4L18.68 10.43Q18.68 13.65 16.43 15.9Q14.18 18.15 10.95 18.15ZM5.85 7.75L16.02 7.75L16.02 4.85L5.85 4.85ZM18.68 7.75L18.75 7.75Q19.32 7.75 19.74 7.33Q20.15 6.9 20.15 6.3Q20.15 5.7 19.74 5.28Q19.32 4.85 18.75 4.85L18.68 4.85ZM4.53 21.8Q3.98 21.8 3.59 21.41Q3.2 21.02 3.2 20.48Q3.2 19.93 3.59 19.54Q3.98 19.15 4.53 19.15L19.5 19.15Q20.05 19.18 20.43 19.55Q20.8 19.93 20.8 20.48Q20.8 21.02 20.41 21.41Q20.02 21.8 19.48 21.8Z" fill={color} />
    </svg>
  );
}
